module.exports = __webpack_public_path__ + "img/Image 9.d624ed2a.png";